<template>
  <div class="template">
    <div class="search">
      <div class="search-center">
        <div class="search-item">
          <DatePicker
            type="daterange"
            placement="bottom-start"
            v-model="search.dateRange"
            format="yyyy-MM-dd"
            placeholder="消费日期范围"
            style="width: 200px;"
          ></DatePicker>
        </div>
        <div class="search-item">
          <DatePicker
            type="month"
            v-model="search.recoredMonth"
            format="yyyy-MM"
            placeholder="归属月份"
            style="width: 150px;"
          ></DatePicker>
        </div>
        <div class="search-item">
          <Select clearable style="width:120px;" v-model="search.incomeType" placeholder="收支类型">
            <Option value="支出">支出</Option>
            <Option value="收入">收入</Option>
          </Select>
        </div>
        <div class="search-item">
          <Select clearable style="width:120px;" v-model="search.category" placeholder="一级分类">
            <Option value="物料">物料费</Option>
            <Option value="安装费">安装费</Option>
            <Option value="工资">工资</Option>
            <Option value="租赁">租赁</Option>
            <Option value="差旅">差旅</Option>
            <Option value="办公费">办公费</Option>
            <Option value="借款">借款</Option>
            <Option value="线下收入">线下收入</Option>
          </Select>
        </div>
        <div class="search-item">
          <Select clearable style="width:120px;" v-model="search.status" placeholder="状态">
            <Option value="draft">草稿</Option>
            <Option value="confirmed">已确认</Option>
            <Option value="cancelled">作废</Option>
          </Select>
        </div>
        <div class="search-item">
          <Select clearable style="width:120px;" v-model="search.isReconciled" placeholder="对账状态">
            <Option :value="0">未对账</Option>
            <Option :value="1">已对账</Option>
          </Select>
        </div>
        <div class="search-item">
          <Input clearable v-model="search.keyword" placeholder="备注/收款方" style="width: 150px;"></Input>
        </div>
        <Button
          style="width: 80px;margin-right: 10px;margin-bottom:5px"
          type="primary"
          icon="ios-search"
          @click="searchFn"
        >查询</Button>
      </div>
    </div>

    <div class="search" style="margin-top: 10px;">
      <div class="search-center">
        <Button type="primary" @click="addBill">+ 新增收支明细</Button>
        <Upload
          :action="importUrl"
          :headers="headers"
          :before-upload="beforeImport"
          :on-success="importSuccess"
          :on-error="importError"
          :format="['xls','xlsx']"
          :on-format-error="importFormatError"
          :show-upload-list="false"
          name="file"
          style="display:inline-block;margin-left:10px;"
        >
          <Button icon="ios-cloud-upload-outline" :loading="importing">导入 Excel</Button>
        </Upload>
        <span style="margin-left:10px;color:#999;font-size:12px;">
          表头列：时间 / 金额 / 备注 / 分类 / 所属 / 收款方（金额>0为收入，<0为支出）
        </span>
      </div>
    </div>

    <div class="table">
      <div class="summary-bar">
        <span class="summary-item">本页收入合计：<em class="income">+¥{{ summary.income }}</em></span>
        <span class="summary-item">本页支出合计：<em class="expense">-¥{{ summary.expense }}</em></span>
        <span class="summary-item">本页结余：<em :class="summary.balanceNum >= 0 ? 'income' : 'expense'">{{ summary.balanceNum >= 0 ? '+' : '-' }}¥{{ summary.balance }}</em></span>
        <span class="summary-item summary-count">本页条数：{{ apiData.tableList.length }} / 总计 {{ apiData.total }}</span>
        <Button type="primary" size="small" icon="ios-pie" @click="openAnalysis" style="margin-left:12px;">分析</Button>
      </div>
      <Table :columns="diyData.columns" :data="apiData.tableList"></Table>
      <div class="page-wrap">
        <Page
          :total="apiData.total"
          show-total
          :page-size="search.pageSize"
          :page-size-opts="[10, 20, 50, 100, 200, 500, 1000]"
          :current="search.pageNo"
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
          class-name="footer-page"
          show-elevator
          show-sizer
          transfer
        ></Page>
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <Modal v-model="diyDom.showModal" :title="form.id ? '编辑收支明细' : '新增收支明细'" width="700">
      <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
        <Row>
          <Col span="12">
            <FormItem label="业务日期" prop="recoredDate">
              <DatePicker type="date" v-model="form.recoredDate" format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%;" @on-change="onDateChange"></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="归属月份" prop="recoredMonth">
              <DatePicker type="month" v-model="form.recoredMonth" format="yyyy-MM" placeholder="选择月份" style="width: 100%;" @on-change="onMonthChange"></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="收支类型" prop="incomeType">
              <Select v-model="form.incomeType" placeholder="请选择">
                <Option value="收入">收入</Option>
                <Option value="支出">支出</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="金额" prop="amount">
              <InputNumber v-model="form.amount" :min="0" :precision="2" :step="100" style="width: 100%;"></InputNumber>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="一级分类" prop="category">
              <AutoComplete v-model="form.category" placeholder="请选择或输入" :data="diyData.categoryList" @on-change="onCategoryChange" transfer></AutoComplete>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="二级分类">
              <Input v-model="form.subCategory" placeholder="如:机票、酒店"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="付款方式">
              <Select v-model="form.paymentMethod" placeholder="请选择" clearable>
                <Option value="公账">公账</Option>
                <Option value="私账">私账</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="收款方">
              <Input v-model="form.payee" placeholder="收款方"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="业务类型">
              <Input v-model="form.type" placeholder="业务类型/标签"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="项目编码">
              <Input v-model="form.projectCode" placeholder="项目编码/归属"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="发票号码">
              <Input v-model="form.invoiceNo" placeholder="发票号码"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="状态">
              <Select v-model="form.status" placeholder="请选择">
                <Option value="draft">草稿</Option>
                <Option value="confirmed">已确认</Option>
                <Option value="cancelled">作废</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <FormItem label="图片凭证">
          <div class="upload-Img">
            <template v-if="form.imageUrls">
              <div class="look-img" v-for="(url, idx) in imageList" :key="idx" style="display:inline-block;margin-right:10px;">
                <img :src="url" style="width: 80px; height: 80px; object-fit: cover;" />
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="previewImage(url)"></Icon>
                  <Icon type="ios-trash-outline" @click.native="removeImage(idx)"></Icon>
                </div>
              </div>
            </template>
            <Upload
              :action="uploadUrl"
              :headers="headers"
              :on-error="uploadErr"
              :on-success="uploadSuccess"
              :before-upload="beforeUpload"
              :format="['jpg','jpeg','png','gif','bmp','webp']"
              :on-format-error="formatError"
              :max-size="10240"
              :on-exceeded-size="sizeError"
              name="file"
              :show-upload-list="false"
              style="display: inline-block;"
            >
              <div class="upload-btn" style="width:80px;height:80px;line-height:80px;">
                <Icon type="ios-cloud-upload" size="30" style="color: #3399ff"></Icon>
              </div>
            </Upload>
          </div>
        </FormItem>
        <FormItem label="备注">
          <Input v-model="form.remark" type="textarea" :rows="3" placeholder="备注信息"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button style="width: 90px" @click="modalCancel">返回</Button>
        <Button type="primary" style="width: 90px; margin-left: 20px" @click="submitSave">保存</Button>
      </div>
    </Modal>
    <Modal v-model="previewVisible" :title="'图片预览'" footer-hide width="800" :styles="{ top: '40px' }">
      <div style="text-align:center; max-height: 75vh; overflow: auto;">
        <img v-if="previewUrl" :src="previewUrl" style="max-width: 100%; max-height: 75vh; object-fit: contain;" />
      </div>
    </Modal>

    <!-- 本页分类分析弹窗 -->
    <Modal v-model="analysisVisible" title="本页分类分析" footer-hide width="1080" :styles="{ top: '40px' }">
      <div v-if="analysisVisible" class="analysis-wrap">
        <Row :gutter="16">
          <Col :span="12">
            <ChartPie
              v-if="analysisData.expensePie.length"
              :value="analysisData.expensePie"
              text="支出分类占比"
              :subtext="'合计 ¥' + analysisData.expenseTotal"
              style="width:100%;height:360px;"
            />
            <div v-else class="analysis-empty">本页无支出数据</div>
          </Col>
          <Col :span="12">
            <ChartPie
              v-if="analysisData.incomePie.length"
              :value="analysisData.incomePie"
              text="收入分类占比"
              :subtext="'合计 ¥' + analysisData.incomeTotal"
              style="width:100%;height:360px;"
            />
            <div v-else class="analysis-empty">本页无收入数据</div>
          </Col>
        </Row>
        <Row style="margin-top:16px;">
          <Col :span="24">
            <ChartBar
              v-if="Object.keys(analysisData.barData).length"
              :value="analysisData.barData"
              text="分类金额柱状图（支出）"
              style="width:100%;height:320px;"
            />
          </Col>
        </Row>
        <div class="analysis-table">
          <Table :columns="analysisData.columns" :data="analysisData.rows" size="small" border></Table>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  apiBillDetailList,
  apiBillDetailSave,
  apiBillDetailDelete,
  apiBillDetailReconcile
} from '@/api/bill-detail.js'
import { ChartPie, ChartBar } from '@/components/charts'

export default {
  name: '/bill-detail',
  components: { ChartPie, ChartBar },
  data() {
    return {
      headers: {
        token: localStorage.getItem('token')
      },
      uploadUrl: process.env.VUE_APP_API_URL + '/upload-file',
      importUrl: process.env.VUE_APP_API_URL + '/billDetail/import',
      importing: false,
      search: {
        dateRange: [],
        recoredMonth: '',
        incomeType: '支出',
        category: '',
        status: '',
        isReconciled: '',
        keyword: '',
        pageNo: 1,
        pageSize: 10
      },
      diyDom: {
        showModal: false
      },
      previewVisible: false,
      previewUrl: '',
      analysisVisible: false,
      analysisData: {
        expensePie: [],
        incomePie: [],
        barData: {},
        expenseTotal: '0.00',
        incomeTotal: '0.00',
        columns: [
          { title: '分类', key: 'category' },
          { title: '类型', key: 'incomeType', width: 90 },
          { title: '笔数', key: 'count', width: 90, align: 'right' },
          {
            title: '金额',
            key: 'amount',
            align: 'right',
            render: (h, params) => {
              const color = params.row.incomeType === '收入' ? '#19be6b' : '#ed4014'
              const prefix = params.row.incomeType === '收入' ? '+' : '-'
              return h('span', { style: { color } }, prefix + '¥' + Number(params.row.amount).toFixed(2))
            }
          },
          {
            title: '占比',
            key: 'percent',
            width: 120,
            align: 'right',
            render: (h, params) => h('span', params.row.percent + '%')
          }
        ],
        rows: []
      },
      form: {
        id: '',
        recoredDate: new Date(),
        recoredMonth: new Date(),
        incomeType: '支出',
        amount: null,
        category: '',
        subCategory: '',
        type: '',
        projectCode: '',
        payee: '',
        paymentMethod: '私账',
        invoiceNo: '',
        imageUrls: '',
        status: 'confirmed',
        isReconciled: 0,
        remark: ''
      },
      diyData: {
        categoryList: ['物料费', '安装费', '工资', '租赁', '差旅', '办公费', '借款', '线下收入'],
        rules: {
          incomeType: [{ required: true, message: '请选择收支类型', trigger: 'change' }],
          amount: [{ required: true, type: 'number', message: '请输入金额', trigger: 'blur' }],
          recoredDate: [{
            required: true,
            validator: (rule, value, cb) => {
              if (!value) return cb(new Error('请选择业务日期'))
              cb()
            },
            trigger: 'change'
          }],
          recoredMonth: [{
            required: true,
            validator: (rule, value, cb) => {
              if (!value) return cb(new Error('请选择归属月份'))
              cb()
            },
            trigger: 'change'
          }],
          category: [{ required: true, message: '请选择一级分类', trigger: 'blur' }]
        },
        columns: [
          {
            title: '序号',
            width: 70,
            align: 'center',
            render: (h, params) => {
              return h('span', (this.search.pageNo - 1) * this.search.pageSize + params.index + 1)
            }
          },
          {
            title: '业务日期',
            width: 110,
            key: 'recoredDate'
          },
          {
            title: '归属月份',
            width: 100,
            key: 'recoredMonth',
            render: (h, params) => {
              if (!params.row.recoredMonth) return ''
              const d = params.row.recoredMonth
              const str = typeof d === 'string' ? d : ''
              return h('span', str.substring(0, 7))
            }
          },
          {
            title: '类型',
            width: 80,
            key: 'incomeType',
            render: (h, params) => {
              const color = params.row.incomeType === '收入' ? '#92f442' : '#ed4014'
              return h('span', { style: { color: color, fontWeight: 'bold' } }, params.row.incomeType)
            }
          },
          {
            title: '金额',
            width: 120,
            key: 'amount',
            sortable: true,
            render: (h, params) => {
              const color = params.row.incomeType === '收入' ? '#92f442' : '#ed4014'
              const prefix = params.row.incomeType === '收入' ? '+' : '-'
              return h('span', { style: { color: color } }, prefix + '¥' + (params.row.amount || 0).toFixed(2))
            }
          },
          {
            title: '分类',
            width: 160,
            key: 'category',
            sortable: true,
            sortMethod: (a, b, type) => {
              const sa = (a || '') + (type ? '' : '')
              const sb = (b || '')
              return type === 'asc' ? sa.localeCompare(sb, 'zh-CN') : sb.localeCompare(sa, 'zh-CN')
            },
            render: (h, params) => {
              return h('span', [params.row.category, params.row.subCategory ? ' / ' + params.row.subCategory : ''])
            }
          },
           {
            title: '备注',
            minWidth: 120,
            key: 'remark',
            tooltip: true
          },
          {
            title: '收款方',
            width: 100,
            key: 'payee'
          },
          {
            title: '付款方式',
            width: 100,
            key: 'paymentMethod'
          },
           {
            title: '业务类型',
            width: 100,
            key: 'type'
          },
          {
            title: '项目编码',
            width: 100,
            key: 'projectCode'
          },
          {
            title: '发票号码',
            width: 120,
            key: 'invoiceNo'
          },
          {
            title: '图片凭证',
            width: 140,
            key: 'imageUrls',
            render: (h, params) => {
              const urls = (params.row.imageUrls || '').split(',').filter(u => u)
              if (urls.length === 0) return h('span', { style: { color: '#c5c8ce' } }, '无')
              return h(
                'div',
                { style: { display: 'flex', alignItems: 'center', flexWrap: 'wrap' } },
                urls.map((url, idx) =>
                  h('img', {
                    attrs: { src: url },
                    style: {
                      height: '40px',
                      width: 'auto',
                      marginRight: '4px',
                      marginTop: '2px',
                      marginBottom: '2px',
                      border: '1px solid #e8eaec',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    },
                    on: {
                      click: () => {
                        this.previewImage(url)
                      }
                    }
                  })
                )
              )
            }
          },
          {
            title: '操作',
            width: 200,
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h(
                  'a',
                  {
                    style: { marginRight: '10px', color: '#2D8cF0' },
                    on: {
                      click: () => {
                        this.editBill(params.row)
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'a',
                  {
                    style: { marginRight: '10px', color: params.row.isReconciled ? '#c5c8ce' : '#19be6b' },
                    on: {
                      click: () => {
                        if (!params.row.isReconciled) {
                          this.reconcileBill(params.row.id)
                        }
                      }
                    }
                  },
                  '对账'
                ),
                h(
                  'a',
                  {
                    style: { color: '#ed4014' },
                    on: {
                      click: () => {
                        this.deleteBill(params.row.id)
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ]
      },
      apiData: {
        total: 0,
        tableList: []
      }
    }
  },
  computed: {
    imageList() {
      if (!this.form.imageUrls) return []
      return this.form.imageUrls.split(',').filter(u => u)
    },
    summary() {
      let income = 0
      let expense = 0
      ;(this.apiData.tableList || []).forEach(row => {
        const amt = Number(row.amount) || 0
        if (row.incomeType === '收入') income += amt
        else if (row.incomeType === '支出') expense += amt
      })
      const balanceNum = income - expense
      return {
        income: income.toFixed(2),
        expense: expense.toFixed(2),
        balance: Math.abs(balanceNum).toFixed(2),
        balanceNum: balanceNum
      }
    }
  },
  methods: {
    // 本页分类分析
    openAnalysis() {
      const list = this.apiData.tableList || []
      if (!list.length) {
        this.$Message.warning('本页无数据可分析')
        return
      }
      const expenseMap = {}
      const incomeMap = {}
      let expenseTotal = 0
      let incomeTotal = 0
      list.forEach(row => {
        const cat = row.category || '未分类'
        const amt = Number(row.amount) || 0
        if (row.incomeType === '收入') {
          incomeMap[cat] = incomeMap[cat] || { amount: 0, count: 0 }
          incomeMap[cat].amount += amt
          incomeMap[cat].count += 1
          incomeTotal += amt
        } else if (row.incomeType === '支出') {
          expenseMap[cat] = expenseMap[cat] || { amount: 0, count: 0 }
          expenseMap[cat].amount += amt
          expenseMap[cat].count += 1
          expenseTotal += amt
        }
      })
      const expensePie = Object.keys(expenseMap).map(k => ({ name: k, value: Number(expenseMap[k].amount.toFixed(2)) }))
      const incomePie = Object.keys(incomeMap).map(k => ({ name: k, value: Number(incomeMap[k].amount.toFixed(2)) }))
      expensePie.sort((a, b) => b.value - a.value)
      incomePie.sort((a, b) => b.value - a.value)
      const barData = {}
      expensePie.forEach(i => { barData[i.name] = i.value })
      const rows = []
      expensePie.forEach(i => {
        const percent = expenseTotal > 0 ? ((i.value / expenseTotal) * 100).toFixed(2) : '0.00'
        rows.push({ category: i.name, incomeType: '支出', count: expenseMap[i.name].count, amount: i.value, percent })
      })
      incomePie.forEach(i => {
        const percent = incomeTotal > 0 ? ((i.value / incomeTotal) * 100).toFixed(2) : '0.00'
        rows.push({ category: i.name, incomeType: '收入', count: incomeMap[i.name].count, amount: i.value, percent })
      })
      this.analysisData.expensePie = expensePie
      this.analysisData.incomePie = incomePie
      this.analysisData.barData = barData
      this.analysisData.expenseTotal = expenseTotal.toFixed(2)
      this.analysisData.incomeTotal = incomeTotal.toFixed(2)
      this.analysisData.rows = rows
      this.analysisVisible = true
    },
    // 分页
    pageChange(e) {
      this.search.pageNo = e
      this.getTableList()
    },
    pageSizeChange(e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    // 搜索
    searchFn() {
      this.search.pageNo = 1
      this.getTableList()
    },
    getTableList() {
      this.$store.commit('setSpinShow', true)
      var opt = { ...this.search }
      // 处理日期范围
      if (opt.dateRange && opt.dateRange.length === 2 && opt.dateRange[0] && opt.dateRange[1]) {
        opt.recoredDateStart = this.formatDate(opt.dateRange[0])
        opt.recoredDateEnd = this.formatDate(opt.dateRange[1])
      }
      // 处理月份
      if (opt.recoredMonth) {
        opt.recoredMonth = this.formatMonthQuery(opt.recoredMonth)
      }
      delete opt.dateRange
      apiBillDetailList(opt).then(res => {
        const { list, totalCount } = res.data
        this.apiData.tableList = list
        this.apiData.total = totalCount
      }).finally(() => this.$store.commit('setSpinShow', false))
    },
    formatDate(date) {
      if (!date) return ''
      if (typeof date === 'string') {
        // 已经是 yyyy-MM-dd 格式，直接返回
        if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date
      }
      const d = new Date(date)
      if (isNaN(d.getTime())) return ''
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    formatMonth(date) {
      if (!date) return ''
      let d
      if (typeof date === 'string') {
        // 处理 "2026-05" 或 "2026-05-09" 格式
        if (date.length <= 7) {
          return date
        }
        d = new Date(date)
      } else {
        d = date
      }
      if (isNaN(d.getTime())) return ''
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      return year + '-' + month
    },
    formatMonthQuery(date) {
      if (!date) return ''
      let d
      if (typeof date === 'string') {
        if (date.length <= 7) {
          return date.substring(0, 7)
        }
        d = new Date(date)
      } else {
        d = date
      }
      if (isNaN(d.getTime())) return ''
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      return year + '-' + month
    },
    // 字符串/Date 统一转为 Date 对象，避免 DatePicker 校验及显示异常
    toDate(v) {
      if (!v) return ''
      if (v instanceof Date) return isNaN(v.getTime()) ? '' : v
      if (typeof v === 'string') {
        // 兼容 'yyyy-MM' / 'yyyy-MM-dd' / 'yyyy-MM-dd HH:mm:ss'
        let s = v
        if (/^\d{4}-\d{2}$/.test(s)) s = s + '-01'
        const d = new Date(s.replace(/-/g, '/'))
        return isNaN(d.getTime()) ? '' : d
      }
      return ''
    },
    addBill() {
      this.form = {
        id: '',
        recoredDate: new Date(),
        recoredMonth: new Date(),
        incomeType: '支出',
        amount: null,
        category: '',
        subCategory: '',
        type: '',
        projectCode: '',
        payee: '',
        paymentMethod: '私账',
        invoiceNo: '',
        imageUrls: '',
        status: 'confirmed',
        isReconciled: 0,
        remark: ''
      }
      this.diyDom.showModal = true
      this.$nextTick(() => {
        if (this.$refs.addForm) this.$refs.addForm.resetFields()
      })
    },
    editBill(row) {
      this.form = {
        id: row.id,
        recoredDate: this.toDate(row.recoredDate),
        recoredMonth: this.toDate(row.recoredMonth),
        incomeType: row.incomeType,
        amount: row.amount,
        category: row.category,
        subCategory: row.subCategory,
        type: row.type,
        projectCode: row.projectCode,
        payee: row.payee,
        paymentMethod: row.paymentMethod,
        invoiceNo: row.invoiceNo,
        imageUrls: row.imageUrls,
        status: row.status,
        isReconciled: row.isReconciled,
        remark: row.remark
      }
      this.diyDom.showModal = true
      this.$nextTick(() => {
        if (this.$refs.addForm) this.$refs.addForm.clearValidate && this.$refs.addForm.clearValidate()
      })
    },
    deleteBill(id) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除该收支明细？',
        onOk: () => {
          apiBillDetailSave({ id, status: 'cancelled' }).then(res => {
            this.$Message.success('删除成功')
            this.getTableList()
          })
        }
      })
    },
    reconcileBill(id) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认标记该明细为已对账？',
        onOk: () => {
          apiBillDetailReconcile({ id }).then(res => {
            this.$Message.success('对账成功')
            this.getTableList()
          })
        }
      })
    },
    modalCancel() {
      this.diyDom.showModal = false
      if (this.$refs.addForm && this.$refs.addForm.clearValidate) {
        this.$refs.addForm.clearValidate()
      }
    },
    onCategoryChange(val) {
      // 切换一级分类时清空二级分类
      this.form.subCategory = ''
    },
    onDateChange() {
      this.$refs.addForm.validateField('recoredDate')
    },
    onMonthChange() {
      this.$refs.addForm.validateField('recoredMonth')
    },
    beforeUpload() {
      // 每次上传前刷新 token，避免 headers 过期导致鉴权失败
      this.headers.token = localStorage.getItem('token')
      return true
    },
    formatError(file) {
      this.$Modal.error({ title: '提示', content: '文件【' + file.name + '】格式错误，仅支持图片(jpg/png/gif/webp)' })
    },
    sizeError(file) {
      this.$Modal.error({ title: '提示', content: '文件【' + file.name + '】超过 10MB，请压缩后重试' })
    },
    uploadSuccess(res) {
      // 兼容包装 {code,msg,data} 和直接返回 {fileUrl}
      const body = res && res.data ? res.data : res
      if (res && res.code != null && res.code !== 200 && res.code !== 0) {
        return this.$Modal.error({ title: '提示', content: res.msg || '上传失败' })
      }
      if (!body || !body.fileUrl) {
        return this.$Modal.error({ title: '提示', content: '上传失败：返回数据异常' })
      }
      this.$Message.success('文件上传成功')
      const url = body.fileUrl
      if (this.form.imageUrls) {
        this.form.imageUrls += ',' + url
      } else {
        this.form.imageUrls = url
      }
    },
    uploadErr(err, file, fileList) {
      this.$Spin.hide()
      let msg = '文件上传失败，请重试'
      // iView 在 HTTP 非 2xx 时，err.message 通常是 'fail to post ...'
      // 真正的后端错误信息需要从 XHR 的 responseText 里解析
      try {
        if (err && err.message) {
          msg = err.message
        }
        // iView 2.x 会把响应体挂到 file.response 上（部分版本）
        if (file && file.response) {
          const resp = typeof file.response === 'string' ? JSON.parse(file.response) : file.response
          if (resp && resp.msg) msg = resp.msg
        }
      } catch (e) {
        // ignore
      }
      console.error('[bill-detail upload error]', err, file)
      this.$Modal.error({ title: '上传失败', content: msg })
    },
    previewImage(url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    beforeImport() {
      // 刷新 token，防止鉴权过期
      this.headers.token = localStorage.getItem('token')
      this.importing = true
      return true
    },
    importFormatError(file) {
      this.importing = false
      this.$Modal.error({ title: '提示', content: '文件【' + file.name + '】格式错误，仅支持 .xls / .xlsx' })
    },
    importSuccess(res) {
      this.importing = false
      if (res && res.code != null && res.code !== 200 && res.code !== 0) {
        return this.$Modal.error({ title: '导入失败', content: res.msg || '未知错误' })
      }
      const count = (res && res.count) || (res && res.data && res.data.count) || 0
      this.$Message.success('导入成功，共 ' + count + ' 条')
      this.searchFn()
    },
    importError(err, file) {
      this.importing = false
      let msg = '导入失败，请重试'
      try {
        if (file && file.response) {
          const resp = typeof file.response === 'string' ? JSON.parse(file.response) : file.response
          if (resp && resp.msg) msg = resp.msg
        } else if (err && err.message) {
          msg = err.message
        }
      } catch (e) {
        // ignore
      }
      console.error('[bill-detail import error]', err, file)
      this.$Modal.error({ title: '导入失败', content: msg })
    },
    removeImage(idx) {
      const list = this.imageList
      list.splice(idx, 1)
      this.form.imageUrls = list.join(',')
    },
    submitSave() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return
        const data = { ...this.form }
        // 格式化日期
        if (data.recoredDate) {
          data.recoredDate = this.formatDate(data.recoredDate)
        }
        if (data.recoredMonth) {
          data.recoredMonth = this.formatMonth(data.recoredMonth)
        }
        apiBillDetailSave(data).then(res => {
          this.$Message.success('保存成功')
          this.diyDom.showModal = false
          if (this.$refs.addForm && this.$refs.addForm.clearValidate) {
            this.$refs.addForm.clearValidate()
          }
          this.getTableList()
        })
      })
    }
  },
  mounted() {
    this.getTableList()
  }
}
</script>

<style scoped lang="less">
.template {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.search {
  display: flex;
  justify-content: space-between;
}
.search-center {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.search-item {
  margin-right: 10px;
  margin-bottom: 5px;
}
.page-wrap {
  margin-top: 12px;
  text-align: right;
}
.summary-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px 14px;
  margin-bottom: 10px;
  background: #f8f9fb;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  font-size: 13px;
  color: #515a6e;
}
.summary-item {
  margin-right: 24px;
  em {
    font-style: normal;
    font-weight: bold;
    margin-left: 4px;
  }
  .income {
    color: #19be6b;
  }
  .expense {
    color: #ed4014;
  }
}
.summary-count {
  margin-left: auto;
  color: #808695;
  em {
    color: #515a6e;
  }
}
.analysis-wrap {
  .analysis-empty {
    height: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    background: #fafafa;
    border: 1px dashed #e8eaec;
    border-radius: 4px;
  }
  .analysis-table {
    margin-top: 16px;
  }
}
.look-img {
  position: relative;
  display: inline-block;
  &:hover .demo-upload-list-cover {
    display: block;
  }
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  line-height: 80px;
  i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 5px;
  }
}
</style>
